var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../store';
import { updateIsActiveParticipantsPanel } from '../../store/slices/bottomIconsActivitySlice';
import { updateSelectedTabLeftPanel } from '../../store/slices/roomSettingsSlice';
const NewPollMsg = ({ closeToast }) => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const openPoll = () => {
        dispatch(updateIsActiveParticipantsPanel(true));
        dispatch(updateSelectedTabLeftPanel(1));
        if (closeToast) {
            closeToast();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("span", { className: "text-black dark:text-darkText", children: t('polls.new-poll') }), _jsx("div", { className: "button-section flex items-center justify-start", children: _jsx("button", { className: "text-center py-1 px-3 mt-1 text-xs transition ease-in bg-primaryColor hover:bg-secondaryColor text-white font-semibold rounded-lg", onClick: openPoll, children: t('open') }) })] }));
};
_react_refresh_temp_1 = NewPollMsg;
$RefreshReg$(_react_refresh_temp_1, "NewPollMsg");
_react_refresh_temp_2(NewPollMsg, "MhnPLnLudZ6xjVXASzA9P5WaQQI=", false, () => [useTranslation, useAppDispatch]);
export default NewPollMsg;
